module.exports = __webpack_public_path__ + "static/media/zw.98a0162e.svg";